import { effect, piercedRoll } from "../fmt";
import { Effect } from "./Effect";
import type { ArmorProfileData, Ruleset } from "./Ruleset";

export class ArmorProfile {
  ruleset: Ruleset;
  data: ArmorProfileData;

  constructor(ruleset: Ruleset, data: ArmorProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get rolls() {
    return this.data.rolls;
  }

  get effects() {
    return (
      this.data.effects?.map((data) => Effect.from(this.ruleset, data)) ?? []
    );
  }

  get summary() {
    return [piercedRoll(this.rolls), ...this.effects.map(effect)].join(" ");
  }
}
